export const stringifyFn = (value: any): string => value?.name || '';
